export const roleTitles = {
  associate_agent: 'Associate Agent',
  lead_agent: 'Lead Agent',
  office_support: 'Office Support',
  remote_support: 'Remote Support',
}

export const memberRoles = [
  { key: 'associate_agent', title: roleTitles.associate_agent, sort: 1 },
  { key: 'lead_agent', title: roleTitles.lead_agent, sort: 0 },
  { key: 'office_support', title: roleTitles.office_support, sort: 2 },
  { key: 'remote_support', title: roleTitles.remote_support, sort: 3 },
]

export default roleTitles
